'use strict';
fm1099OverrideController.$inject = ['$scope', '$q', 'dialogHelper', 'fm1099Service', 'BUSY_MESSAGE'];
angular.module('schoolLinqApp').controller('fm1099OverrideController', fm1099OverrideController);

function fm1099OverrideController($scope, $q, dialogHelper, fm1099Service, BUSY_MESSAGE) {
	var viewModel = getViewModel();
	$scope.vm = viewModel;

	$scope.vm.busyPromise = $q.all([$scope.vm.loadForm($scope.vm)]);

	function getViewModel() {
		var model = {
			taxYears: [],
			selectedTaxYear: null,
			isFinalized: false,
			filter: {
				search: '',
				propertyName: 'VendorName',
				reverse: false,
			},
			pageSize: 12,
			startIndex: 0,
			vendors: [],
			busyPromise: null,
			busyMessage: BUSY_MESSAGE.Loading,
			errors: null,
		};

		function loadForm(model) {
			return fm1099Service.getTaxYears().then(_.partial(finishLoadingForm, model));

			function finishLoadingForm(model, response) {
				model.taxYears = response.data.taxYears;

				var currentYear = new Date().getFullYear();
				if (
					_.filter(model.taxYears, function (year) {
						return year === currentYear;
					}).length > 0
				) {
					model.selectedTaxYear = currentYear;
				} else {
					model.selectedTaxYear = model.taxYears[0];
				}
				model.eventRefresh($scope.vm);
			}
		}

		function eventRefresh(model) {
			resetModel($scope.vm);

			model.busyMessage = BUSY_MESSAGE.Loading;
			model.busyPromise = loadVendors(model);
		}

		function resetModel(model) {
			model.vendors = [];
			model.isFinalized = false;
			model.filter.search = '';
			model.filter.propertyName = 'VendorName';
			model.filter.reverse = false;
			model.isDirty = false;
			$scope.form1099Override.$setPristine();
		}

		function formIsDirty() {
			if ($scope.form1099Override.$dirty && $scope.vm.isDirty === false) {
				$scope.form1099Override.$setPristine();
			}

			return $scope.form1099Override.$dirty;
		}

		function loadVendors(model) {
			return fm1099Service.getVendorsForAdjustment(model.selectedTaxYear).then(_.partial(finishedLoadingVendors, model));

			function finishedLoadingVendors(model, response) {
				if (response.data.isValid) {
					model.errors = [];
					model.vendors = response.data.vendors;
					model.isFinalized = response.data.isFinalized;
				} else {
					model.errors.push(response.data.errors);
				}

				return angular.noop;
			}
		}

		function sortBy(model, filter, propertyName) {
			filter.reverse = filter.propertyName === propertyName ? !filter.reverse : false;
			filter.propertyName = propertyName;
		}

		function save(model) {
			var param = {
				TaxYear: model.selectedTaxYear,
				Vendor1099Adjustments: [],
			};

			_.each(model.vendors, function (vendor) {
				if (parseFloat(vendor.Adjustment || 0) !== parseFloat(vendor.AdjustmentClone || 0)) {
					var vObj = {
						CalendarYear: param.TaxYear,
						VendorId: vendor.VendorId,
						Adjustment: parseFloat(vendor.Adjustment || 0),
					};
					param.Vendor1099Adjustments.push(vObj);
				}
			});

			model.busyMessage = BUSY_MESSAGE.Saving;
			model.busyPromise = fm1099Service.save1099Adjustments(param).then(_.partial(finishSaving, model));

			function finishSaving(model, response) {
				if (response.data.isValid === true) {
					_.each(model.vendors, function (vendor) {
						var adjusted = _.find(response.data.adjustments, function (adj) {
							return adj.VendorId === vendor.VendorId;
						});

						if (adjusted) {
							vendor.AdjustmentClone = parseFloat(adjusted.Adjustment || 0);
							vendor.ModifiedBy = adjusted.ModifiedBy;
							vendor.ModifiedDT = adjusted.ModifiedDT;
						}
					});
					model.isDirty = false;
					model.formIsDirty(); // resets to prestine because model.isDirty = false.
				} else {
					// display errors
					model.errors = response.data.errors;
					dialogHelper.openMessageBox('Save Adjustments Error!', model.errors, null, 'Warning');
					return;
				}
			}
		}

		function cancelSave(model) {
			_.each(model.vendors, function (vendor) {
				vendor.Adjustment = vendor.AdjustmentClone;
				vendor.YTDAdjustedEarnings = parseFloat(vendor.YTDEarnings) + parseFloat(vendor.Adjustment || 0) || 0;
			});

			model.isDirty = false;
			model.formIsDirty();
			return;
		}

		return angular.extend(model, {
			formIsDirty: formIsDirty,
			loadForm: _.partial(loadForm, model),
			eventRefresh: _.partial(eventRefresh, model),
			resetModel: _.partial(resetModel, model),
			sortBy: _.partial(sortBy, model),
			save: _.partial(save, model),
			cancelSave: _.partial(cancelSave, model),
			adjustEarnings: function (vendor) {
				vendor.YTDAdjustedEarnings = parseFloat(vendor.YTDEarnings) + parseFloat(vendor.Adjustment || 0) || 0;
				if (parseFloat(vendor.Adjustment || 0) !== parseFloat(vendor.AdjustmentClone || 0)) {
					model.isDirty = true;
				}

				return parseFloat(vendor.YTDAdjustedEarnings);
			},
		});
	}

	var onRouteChangeOff = $scope.$on('$locationChangeStart', _.partial(dialogHelper.routeChange, $scope.vm.formIsDirty, acceptRouteChangeFunction));

	function acceptRouteChangeFunction() {
		onRouteChangeOff(); // Stop listening for location changes
		return angular.noop;
	}
}
